import type { MonitoringSlices } from '.';
import type { StateCreator } from 'zustand';

import type { PlainGeofence, PointOnMap } from '@cobliteam/common-types/src/geofenceV3';

export interface GeofenceSliceState {
  geofenceToEdit: Partial<PlainGeofence> | undefined;
  geofenceToCreate: Partial<PlainGeofence> | undefined;
  pointOnMap: PointOnMap | undefined;
  showGeofenceTour: boolean;
  showGeofenceConfig: boolean;
  deleteGeofenceDrawing: boolean;
  setGeofenceToEdit: (geofence: Partial<PlainGeofence>) => void;
  setGeofenceToCreate: (geofence: Partial<PlainGeofence>) => void;
  setPointOnMap: (point: PointOnMap) => void;
  clearGeofenceToEdit: () => void;
  clearGeofenceToCreate: () => void;
  clearPointOnMap: () => void;
  setDeleteGeofenceDrawing: (enable: boolean) => void;
}

type StateCreatorGeofence = StateCreator<MonitoringSlices, [['zustand/devtools', never]], [], GeofenceSliceState>;

const createGeofencesSlice: StateCreatorGeofence = (set) => ({
  geofenceToEdit: undefined,
  geofenceToCreate: undefined,
  pointOnMap: undefined,
  showGeofenceTour: false,
  showGeofenceConfig: false,
  deleteGeofenceDrawing: false,
  setGeofenceToEdit: (geofence: Partial<PlainGeofence>) =>
    set((state) => ({
      geofenceToEdit: { ...state.geofenceToEdit, ...geofence },
    })),
  setGeofenceToCreate: (geofence: Partial<PlainGeofence>) =>
    set((state) => ({
      geofenceToCreate: { ...state.geofenceToCreate, ...geofence },
    })),
  setPointOnMap: (point: PointOnMap) =>
    set((state) => ({
      pointOnMap: { ...state.pointOnMap, ...point },
    })),
  clearGeofenceToEdit: () => set({ geofenceToEdit: undefined }),
  clearGeofenceToCreate: () => set({ geofenceToCreate: undefined }),
  clearPointOnMap: () => set({ pointOnMap: undefined }),
  setDeleteGeofenceDrawing: (enable: boolean) => set({ deleteGeofenceDrawing: enable }),
});

export default createGeofencesSlice;
